module.exports = __webpack_public_path__ + "static/media/search.edeb9316.svg";